import { Icon, type IconProps, Box } from "@chakra-ui/react";
import React from "react";

export function FacebookTagIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" fill="none" viewBox="0 0 24 24" {...props}>
      <rect width="22.8" height="22.8" x=".801" y=".314" fill="#fff" rx="11.4" />
      <Box as="g" clipPath="url(#fb-tag-a)">
        <Box as="path" fill="#1977F3" d="M12.202 19.316a7.6 7.6 0 1 0 0-15.2 7.6 7.6 0 0 0 0 15.2Z" />
        <Box
          as="path"
          fill="#fff"
          d="m15.16 13.913.337-2.198h-2.108V10.29c0-.601.294-1.188 1.239-1.188h.958v-1.87s-.87-.149-1.701-.149c-1.736 0-2.87 1.052-2.87 2.958v1.674H9.083v2.198h1.93v5.31a7.62 7.62 0 0 0 2.375 0v-5.31h1.77Z"
        />
      </Box>
      <Box
        as="path"
        fill="#6EC22D"
        fillRule="evenodd"
        d="M12.2 21.214a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Zm0 1.9c6.297 0 11.4-5.104 11.4-11.4S18.498.314 12.2.314C5.906.314.8 5.418.8 11.714s5.105 11.4 11.4 11.4Z"
        clipRule="evenodd"
      />
      <Box as="defs">
        <clipPath id="fb-tag-a">
          <Box as="path" fill="#fff" d="M4.602 4.114h15.2v15.2h-15.2z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
